import MgpFormInput from '../../elements/MgpFormInput/MgpFormInput';
import {useEffect, useState} from "react";
import {IBeneficiaryAdditionReq, relationType} from "../../context/model";
import MgpFormSelect from "../../elements/MgpFormSelect/MgpFormSelect";
import MgpFormCheckbox from "../../elements/MgpFormCheckbox/MgpFormCheckbox";
import {FieldErrors, UseFormRegister, UseFormSetValue, UseFormWatch} from "react-hook-form";
import {useFetchNomenclature} from "../../hooks/useFetchNomenclature";
import Modal from 'react-modal';
import MgpDatepicker from '../../elements/MgpDatepicker/MgpDatepicker';
import ImageModal from '../../modals/common/ImageModal';
import MgpMessage from '../../elements/MgpMessage/MgpMessage';



interface InfoBeneficiaryProps extends IBeneficiaryAdditionReq {
  id: number,
  register: UseFormRegister<InfoBeneficiaryStep1FormData>,
  errors: FieldErrors<InfoBeneficiaryStep1FormData>,
  setValue: UseFormSetValue<InfoBeneficiaryStep1FormData>,
  watch: UseFormWatch<InfoBeneficiaryStep1FormData>;
  isOpen?: boolean;
  onConfirmAction: () => void;
  onRefuseAction: () => void;
  onCloseModal: () => void; 
  errorMsgLimitAge?: string | null;
  alertMessage?: string
}

export interface InfoBeneficiaryStep1FormDataProps extends IBeneficiaryAdditionReq {
  withBeneficiary: boolean,
  onModify: boolean
}

export type InfoBeneficiaryStep1FormData = {
  ayantDroits: InfoBeneficiaryStep1FormDataProps[],
}

export default function InfoBeneficiaryComponent(beneficiaryProps: Readonly<InfoBeneficiaryProps>) {
  const [visibility, setVisibility] = useState<boolean>(true);
  const [isDisable, setIsDisable] = useState<boolean>(false);
  const civilityNomenclature = useFetchNomenclature("civility");
  const [imageUrl, setImageUrl] = useState<string>('');
  const [modalText, setModalText] = useState<string>('');

  const [isShowCheckboxHandicap, setIsShowCheckboxHandicap] = useState(beneficiaryProps.relationType === relationType.CHILD);

  function onAddOrRemove(checked: boolean) {
    setIsDisable(!checked);
    setVisibility(checked);
  }

   useEffect(() => {
     if(civilityNomenclature && beneficiaryProps.contact.civilityCode) {
       beneficiaryProps.setValue(`ayantDroits.${beneficiaryProps.id}.contact.civilityCode`, beneficiaryProps.contact.civilityCode);
     }
  }, [civilityNomenclature]);

  let firstName = beneficiaryProps.watch(`ayantDroits.${beneficiaryProps.id}.contact.firstName`, beneficiaryProps.contact.firstName);
  let lastName = beneficiaryProps.watch(`ayantDroits.${beneficiaryProps.id}.contact.lastName`, beneficiaryProps.contact.lastName);

  let addLabel = 'Je souhaite assurer ';
  if(firstName || lastName) {
    addLabel += firstName + ' ' + lastName;
  } else {
    addLabel += "cet ayant droit";
  };

  let alsaceMoselleRegimeLabel = 'Cet ayant droit relève du régime Alsace-Moselle';

  const handleOpenInfoModal = (e: any, image: string, text?: string) => {
    e.preventDefault();
    setImageUrl(image);
    if (text) setModalText(text);
  }

  const handleCloseInfoModal = () => {
    setImageUrl('');
    setModalText('');
  }

  const onChange = (typeRelation:any) => {
    setIsShowCheckboxHandicap(typeRelation === relationType.CHILD);
    if(typeRelation !== relationType.CHILD) {
      beneficiaryProps.setValue(`ayantDroits.${beneficiaryProps.id}.contact.hasHandicap`, false);
    }
  }

  return (
    <Modal isOpen={beneficiaryProps.isOpen || true} onRequestClose={beneficiaryProps.onCloseModal}>
      <div className="modale open">
        <div className="modale--content">
            <div className="modale--content--template">
                <div className="modale--main-width-entreprise shadow-bleu bg-blanc p-md" >
                  <p className='card-title bleu'>Je souhaite ajouter un ayant droit</p>

                  {beneficiaryProps.errorMsgLimitAge && <MgpMessage type="danger" message={beneficiaryProps.errorMsgLimitAge} hasCloseBtn={false}/>}
                  {beneficiaryProps.alertMessage && <MgpMessage type="danger" message={beneficiaryProps.alertMessage} hasCloseBtn={false}/>}

                  <div className='alert alert-bleu m-y-md'>
                    <form style={{width: '100%'}}>

                      <div className="form-row">
                        <div className="form-group mw-33">
                          <MgpFormSelect 
                            id={`ayantDroits.${beneficiaryProps.id}.relationType`} labelFontWeight='regular'
                            data={[
                              {code: `${relationType.CONJOINT}`, label: 'Mon/Ma conjoint(e)'},
                              {code: `${relationType.CONCUBIN}`, label: 'Mon/Ma concubin(e)'},
                              {code: `${relationType.CHILD}`, label: 'Mon enfant'}
                            ]}
                            register={beneficiaryProps.register}
                            errors={beneficiaryProps.errors}
                            disabled={isDisable}
                            label='Lien familial'
                            required={true}
                            onChange={(e) => onChange(e.target.value)}
                          />
                        </div>
                      </div>
      
                      <div className="form-row">
                       
                      </div>

                      <div className="form-row">
                      <div className="form-group mw-33">
                          <MgpFormSelect 
                            id={`ayantDroits.${beneficiaryProps.id}.contact.civilityCode`} labelFontWeight='regular'
                            data={civilityNomenclature.options}
                            register={beneficiaryProps.register}
                            errors={beneficiaryProps.errors}
                            disabled={isDisable}
                            label='Civilité'
                            required={true}/>
                        </div>
                        <div className="form-group mw-33">
                          <MgpFormInput
                            label="Prénom"
                            id={`ayantDroits.${beneficiaryProps.id}.contact.firstName`}
                            register={beneficiaryProps.register}
                            errors={beneficiaryProps.errors}
                            disabled={isDisable}
                            labelFontWeight='regular'
                            required={true}
                            autoCapitalize='characters'      
                          />
                        </div>
                        <div className="form-group mw-33">
                          <MgpFormInput
                            label="Nom"
                            id={`ayantDroits.${beneficiaryProps.id}.contact.lastName`}
                            register={beneficiaryProps.register}
                            errors={beneficiaryProps.errors}
                            disabled={isDisable}
                            labelFontWeight='regular'
                            required={true}
                            autoCapitalize='characters'      
                          />
                        </div>
                      </div>

                      <div className="form-row">
                        <div className="form-group mw-33">
                        <div className="form-row">
                            <div className="form-group">
                              <MgpDatepicker 
                                 label="Date de naissance"
                                 id={`ayantDroits.${beneficiaryProps.id}.contact.birthDate`}
                                 register={beneficiaryProps.register}
                                 errors={beneficiaryProps.errors}
                                 disabled={isDisable}
                                 labelFontWeight='regular'
                                 required={true}
                                 value={beneficiaryProps.contact.birthDate}
                                 handleChange= {(date: string) => {
                                    beneficiaryProps.setValue(`ayantDroits.${beneficiaryProps.id}.contact.birthDate`, date)
                                 }}
                              />
                          </div>
                          </div>
                        </div>
                        <div className="form-group mw-33">
                          <div className="form-row">
                            <div className="form-group mw-80">
                              <MgpFormInput
                                label="N° de sécurité sociale"
                                id={`ayantDroits.${beneficiaryProps.id}.contact.nir`}
                                register={beneficiaryProps.register}
                                errors={beneficiaryProps.errors}
                                disabled={isDisable}
                                labelFontWeight='regular'
                                required={true}
                                maxLength={13}
                                tooltipText="Cliquez pour voir les instructions."
                                handleClickInfo={(e: any) => handleOpenInfoModal(e, "Image_AM_CV_entourage_3.jpg", "Il s'agit des 13 premiers numéros présents sur l'attestation de droits ou la carte vitale.")}
                              />
                            </div>
                            <div className="form-group mw-20">
                              <MgpFormInput
                                label="Clé"
                                id={`ayantDroits.${beneficiaryProps.id}.contact.nirKey`}
                                register={beneficiaryProps.register}
                                errors={beneficiaryProps.errors}
                                disabled={isDisable}
                                labelFontWeight='regular'
                                required={true}
                                maxLength={2}
                                tooltipText="Cliquez pour voir les instructions."
                                handleClickInfo={(e: any) => handleOpenInfoModal(e, "Image_AM_CV_entourage_2.jpg", "Il s'agit des deux derniers chiffres de votre numéro de sécurité sociale, composé de 15 chiffres.")}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="form-group mw-33">
                          <div className="form-row">
                            <div className="form-group">
                              <MgpFormInput
                                label="Organisme de rattachement"
                                labelFontWeight='regular'
                                id={`ayantDroits.${beneficiaryProps.id}.contact.attachmentOrganization`}
                                register={beneficiaryProps.register}
                                errors={beneficiaryProps.errors}
                                disabled={isDisable}
                                required={true}
                                maxLength={9}
                                regex={[/(\d{2})(\d{3})(\d{4})/, '$1 $2 $3']}
                                tooltipText="Cliquez pour voir les instructions."
                                handleClickInfo={(e: any) => handleOpenInfoModal(e, "Image_AM_1.jpg", "L'organisme de rattachement est composé de 9 chiffres.")}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="form-row">
                        <div className="form-group form-check  mt-md">
                          <MgpFormCheckbox 
                            id={`ayantDroits.${beneficiaryProps.id}.contact.alsaceMoselleRegime`} 
                            label={alsaceMoselleRegimeLabel} register={beneficiaryProps.register} 
                            errors={beneficiaryProps.errors} />
                        </div> 
                      </div>
                      {isShowCheckboxHandicap &&
                        <div className="form-row">
                          <div className="form-group form-check  mt-md">
                            <MgpFormCheckbox 
                              id={`ayantDroits.${beneficiaryProps.id}.contact.hasHandicap`} 
                              label={"En situation de handicap"} 
                              register={beneficiaryProps.register} errors={beneficiaryProps.errors} />
                          </div> 
                        </div>
                      }
                      
                      <div className='ta-center'>
                        <button className='cta-inline cta-blanc cta-small m-md' onClick={beneficiaryProps.onRefuseAction}>Annuler</button>
                        <button className='cta-inline cta-bleu cta-small m-md' onClick={beneficiaryProps.onConfirmAction}>Confirmer</button>
                      </div>
                    </form>

                    {imageUrl && <ImageModal isOpen={true} name={imageUrl} onCloseModal={handleCloseInfoModal} text={modalText}/>}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
  )
}
